import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Box from "@material-ui/core/Box";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import GitHub from "@material-ui/icons/GitHub";
import YouTube from "@material-ui/icons/YouTube";
import Email from "@material-ui/icons/Email";

const useStyles = makeStyles((theme) => ({
  container: {
    background: "transparent",
    color: "white",
    paddingTop: theme.spacing(6),
    paddingBottom: theme.spacing(6),
  },
  titleWrapper: {
    textAlign: "center",
    marginBottom: theme.spacing(4),
  },
  title: {
    display: "inline-block",
    background: "rgb(0, 0, 0, 0.8)  ",
    borderRadius: theme.shape.borderRadius,
    padding: theme.spacing(1.5, 4),
    textShadow: "0 2px 8px rgba(0, 0, 0, 0.9)",
  },
  linkGrid: {
    maxWidth: 600,
    margin: "0 auto",
  },
  button: {
    margin: theme.spacing(1, 0),
    width: "100%",
    justifyContent: "flex-start",
    background: "rgba(0, 0, 0, 0.75)",
    color: "white",
    textTransform: "none",
    padding: theme.spacing(2.5, 3),
    fontSize: "2.0rem",
    "&:hover": {
      background: "rgba(0, 0, 0, 0.9)",
    },
  },
  discordButton: {
    marginTop: theme.spacing(2),
  },
}));

const WhereToFindMe = () => {
  const classes = useStyles();

  // Replace the Discord invite with your real invite link.
  const DISCORD_INVITE = "https://discord.gg/your-invite";

  return (
    <Box className={classes.container} component="div">
      <Box className={classes.titleWrapper}>
        <Typography variant="h4" className={classes.title}>
          Where to find me
        </Typography>
      </Box>

      <Grid container direction="column" className={classes.linkGrid}>
        <Grid item>
          <Button
            className={classes.button}
            startIcon={<GitHub />}
            href="https://github.com/avery-lockwood"
            target="_blank"
            rel="noopener noreferrer"
          >
            GitHub — github.com/avery-lockwood
          </Button>
        </Grid>

        <Grid item>
          <Button
            className={classes.button}
            startIcon={<Email />}
            href="mailto:avery.lockwood9@gmail.com"
          >
            Email — avery.lockwood9@gmail.com
          </Button>
        </Grid>

        <Grid item>
          <Button
            className={classes.button}
            startIcon={<YouTube />}
            href="https://www.youtube.com/@a.very.lockwood"
            target="_blank"
            rel="noopener noreferrer"
          >
            YouTube — @a.very.lockwood
          </Button>
        </Grid>

        <Grid item>
          <Button
            className={`${classes.button} ${classes.discordButton}`}
            href={DISCORD_INVITE}
            target="_blank"
            rel="noopener noreferrer"
          >
            Discord — Join my server
          </Button>
        </Grid>
      </Grid>
    </Box>
  );
};

export default WhereToFindMe;
